const EXERCISE_DB = [
  // ── CHEST ──────────────────────────────────────────
  { name: "Bench Press", muscles: ["chest", "triceps", "shoulders"] },
  { name: "Incline Bench Press", muscles: ["chest", "shoulders", "triceps"] },
  { name: "Decline Bench Press", muscles: ["chest", "triceps"] },
  { name: "Dumbbell Bench Press", muscles: ["chest", "triceps"] },
  { name: "Incline Dumbbell Press", muscles: ["chest", "shoulders"] },
  { name: "Dumbbell Fly", muscles: ["chest"] },
  { name: "Incline Dumbbell Fly", muscles: ["chest", "shoulders"] },
  { name: "Cable Fly", muscles: ["chest"] },
  { name: "Low Cable Fly", muscles: ["chest"] },
  { name: "High Cable Fly", muscles: ["chest"] },
  { name: "Pec Deck", muscles: ["chest"] },
  { name: "Push Up", muscles: ["chest", "triceps", "shoulders"] },
  { name: "Wide Push Up", muscles: ["chest"] },
  { name: "Chest Dip", muscles: ["chest", "triceps"] },
  { name: "Smith Machine Bench Press", muscles: ["chest", "triceps"] },
  { name: "Landmine Press", muscles: ["chest", "shoulders"] },

  // ── SHOULDERS ──────────────────────────────────────
  { name: "Overhead Press", muscles: ["shoulders", "triceps"] },
  { name: "Dumbbell Shoulder Press", muscles: ["shoulders", "triceps"] },
  { name: "Seated Dumbbell Press", muscles: ["shoulders", "triceps"] },
  { name: "Lateral Raise", muscles: ["shoulders"] },
  { name: "Cable Lateral Raise", muscles: ["shoulders"] },
  { name: "Front Raise", muscles: ["shoulders"] },
  { name: "Cable Front Raise", muscles: ["shoulders"] },
  { name: "Face Pull", muscles: ["shoulders", "back"] },
  { name: "Arnold Press", muscles: ["shoulders", "triceps"] },
  { name: "Upright Row", muscles: ["shoulders", "back"] },
  { name: "Reverse Fly", muscles: ["shoulders", "back"] },
  { name: "Rear Delt Fly", muscles: ["shoulders"] },
  { name: "Rear Delt Cable Fly", muscles: ["shoulders"] },
  { name: "Smith Machine Shoulder Press", muscles: ["shoulders", "triceps"] },
  { name: "Barbell Overhead Press", muscles: ["shoulders", "triceps"] },

  // ── TRICEPS ────────────────────────────────────────
  { name: "Tricep Pushdown", muscles: ["triceps"] },
  { name: "Rope Pushdown", muscles: ["triceps"] },
  { name: "Skull Crusher", muscles: ["triceps"] },
  { name: "Overhead Tricep Extension", muscles: ["triceps"] },
  { name: "Overhead Cable Tricep Extension", muscles: ["triceps"] },
  { name: "Tricep Dip", muscles: ["triceps", "chest"] },
  { name: "Close Grip Bench Press", muscles: ["triceps", "chest"] },
  { name: "Diamond Push Up", muscles: ["triceps", "chest"] },
  { name: "Kickback", muscles: ["triceps"] },
  { name: "Cable Kickback", muscles: ["triceps"] },
  { name: "JM Press", muscles: ["triceps"] },
  { name: "Tate Press", muscles: ["triceps"] },

  // ── BACK ───────────────────────────────────────────
  { name: "Pull Up", muscles: ["back", "biceps"] },
  { name: "Chin Up", muscles: ["back", "biceps"] },
  { name: "Neutral Grip Pull Up", muscles: ["back", "biceps"] },
  { name: "Lat Pulldown", muscles: ["back", "biceps"] },
  { name: "Wide Grip Lat Pulldown", muscles: ["back"] },
  { name: "Close Grip Lat Pulldown", muscles: ["back", "biceps"] },
  { name: "Single Arm Lat Pulldown", muscles: ["back"] },
  { name: "Barbell Row", muscles: ["back", "biceps"] },
  { name: "Pendlay Row", muscles: ["back"] },
  { name: "Dumbbell Row", muscles: ["back", "biceps"] },
  { name: "Single Arm Dumbbell Row", muscles: ["back"] },
  { name: "Cable Row", muscles: ["back"] },
  { name: "Seated Cable Row", muscles: ["back", "biceps"] },
  { name: "T-Bar Row", muscles: ["back"] },
  { name: "Chest Supported Row", muscles: ["back"] },
  { name: "Meadows Row", muscles: ["back"] },
  { name: "Deadlift", muscles: ["back", "glutes", "hamstrings"] },
  { name: "Sumo Deadlift", muscles: ["back", "glutes", "hamstrings"] },
  { name: "Rack Pull", muscles: ["back", "glutes"] },
  { name: "Straight Arm Pulldown", muscles: ["back"] },
  { name: "Hyperextension", muscles: ["back", "glutes"] },
  { name: "Good Morning", muscles: ["back", "hamstrings"] },
  { name: "Shrug", muscles: ["back"] },
  { name: "Dumbbell Shrug", muscles: ["back"] },

  // ── BICEPS ─────────────────────────────────────────
  { name: "Bicep Curl", muscles: ["biceps"] },
  { name: "Barbell Curl", muscles: ["biceps"] },
  { name: "Hammer Curl", muscles: ["biceps"] },
  { name: "Incline Dumbbell Curl", muscles: ["biceps"] },
  { name: "Preacher Curl", muscles: ["biceps"] },
  { name: "Cable Curl", muscles: ["biceps"] },
  { name: "EZ Bar Curl", muscles: ["biceps"] },
  { name: "Concentration Curl", muscles: ["biceps"] },
  { name: "Spider Curl", muscles: ["biceps"] },
  { name: "Reverse Curl", muscles: ["biceps"] },
  { name: "Cross Body Curl", muscles: ["biceps"] },
  { name: "Rope Hammer Curl", muscles: ["biceps"] },
  { name: "21s", muscles: ["biceps"] },

  // ── FOREARMS ───────────────────────────────────────
  { name: "Wrist Curl", muscles: ["forearms"] },
  { name: "Reverse Wrist Curl", muscles: ["forearms"] },
  { name: "Farmers Walk", muscles: ["forearms", "back"] },

  // ── QUADS ──────────────────────────────────────────
  { name: "Squat", muscles: ["quads", "glutes", "hamstrings"] },
  { name: "Front Squat", muscles: ["quads", "glutes"] },
  { name: "Hack Squat", muscles: ["quads", "glutes"] },
  { name: "Leg Press", muscles: ["quads", "glutes"] },
  { name: "Narrow Stance Leg Press", muscles: ["quads"] },
  { name: "Leg Extension", muscles: ["quads"] },
  { name: "Bulgarian Split Squat", muscles: ["quads", "glutes"] },
  { name: "Walking Lunge", muscles: ["quads", "glutes"] },
  { name: "Reverse Lunge", muscles: ["quads", "glutes"] },
  { name: "Sissy Squat", muscles: ["quads"] },
  { name: "Smith Machine Squat", muscles: ["quads", "glutes"] },
  { name: "Goblet Squat", muscles: ["quads", "glutes"] },
  { name: "Pistol Squat", muscles: ["quads", "glutes"] },

  // ── HAMSTRINGS ─────────────────────────────────────
  { name: "Leg Curl", muscles: ["hamstrings"] },
  { name: "Seated Leg Curl", muscles: ["hamstrings"] },
  { name: "Romanian Deadlift", muscles: ["hamstrings", "glutes"] },
  { name: "Stiff Leg Deadlift", muscles: ["hamstrings", "glutes"] },
  { name: "Single Leg Romanian Deadlift", muscles: ["hamstrings", "glutes"] },
  { name: "Nordic Curl", muscles: ["hamstrings"] },
  { name: "Glute Ham Raise", muscles: ["hamstrings", "glutes"] },

  // ── GLUTES ─────────────────────────────────────────
  { name: "Hip Thrust", muscles: ["glutes"] },
  { name: "Barbell Hip Thrust", muscles: ["glutes"] },
  { name: "Glute Bridge", muscles: ["glutes"] },
  { name: "Cable Kickback", muscles: ["glutes"] },
  { name: "Donkey Kick", muscles: ["glutes"] },
  { name: "Sumo Squat", muscles: ["glutes", "quads"] },
  { name: "Step Up", muscles: ["glutes", "quads"] },
  { name: "Abduction Machine", muscles: ["glutes"] },

  // ── CALVES ─────────────────────────────────────────
  { name: "Calf Raise", muscles: ["calves"] },
  { name: "Seated Calf Raise", muscles: ["calves"] },
  { name: "Leg Press Calf Raise", muscles: ["calves"] },
  { name: "Single Leg Calf Raise", muscles: ["calves"] },
  { name: "Donkey Calf Raise", muscles: ["calves"] },

  // ── CORE ───────────────────────────────────────────
  { name: "Plank", muscles: ["core"] },
  { name: "Side Plank", muscles: ["core"] },
  { name: "Crunch", muscles: ["core"] },
  { name: "Sit Up", muscles: ["core"] },
  { name: "Decline Sit Up", muscles: ["core"] },
  { name: "Hanging Leg Raise", muscles: ["core"] },
  { name: "Hanging Knee Raise", muscles: ["core"] },
  { name: "Cable Crunch", muscles: ["core"] },
  { name: "Russian Twist", muscles: ["core"] },
  { name: "Ab Wheel Rollout", muscles: ["core"] },
  { name: "Bicycle Crunch", muscles: ["core"] },
  { name: "Toe Touch", muscles: ["core"] },
  { name: "Dragon Flag", muscles: ["core"] },
  { name: "Pallof Press", muscles: ["core"] },
  { name: "Dead Bug", muscles: ["core"] },
  { name: "Wood Chop", muscles: ["core"] },
  { name: "V-Up", muscles: ["core"] },
];

export default EXERCISE_DB;